import styled, { css } from 'styled-components'
import { Row, Container } from '../Globals/index'
import { sizes } from '@theme'
import A from '@components/A'

export const StyledContentContainer = styled(Container)`
  width: 100%;
  margin-bottom: ${({ marginBottom }) => marginBottom || '0px'};

  @media (max-width: ${sizes.small.max}) {
    max-width: ${sizes.small.min};
    padding: ${({ padding }) => (padding ? '35px 5px 90px' : '0')};
  }

  @media (min-width: ${sizes.medium.min}) {
    max-width: ${sizes.small.max};
    padding: ${({ padding }) => (padding ? '55px 15px 96px' : '0 10px')};
  }

  @media (min-width: ${sizes.large.min}) {
    max-width: 1230px;
    padding: 0px;
  }
`

export const ContentContainer = styled(Container)`
  width: 100%;
  margin-bottom: ${({ marginBottom }) => marginBottom || '0px'};
  padding: ${({ padding }) => (padding ? '30px 5px 90px' : '0px')};

  @media (min-width: 576px) {
    max-width: 570px;
    padding: ${({ padding }) => (padding ? '35px 5px 90px' : '25px 0 0')};
  }
  @media (min-width: 768px) {
    max-width: 740px;
    padding: ${({ padding }) => (padding ? '55px 15px 96px' : '0 10px 0')};
  }
  @media (min-width: 992px) {
    max-width: 960px;
    padding: ${({ padding }) => (padding ? '55px 15px 96px' : '0')};
  }
  @media (min-width: 1200px) {
    max-width: 1200px;
  }
`

export const StyledRowContainer = styled(Row)`
  border-bottom: ${({ index, length }) =>
    index !== length ? '1px solid rgba(95, 96, 98, 0.33)' : '0px'};
  padding: ${({ padding }) => padding || '0px'};

  @media (min-width: 992px) {
    max-width: 960px;
    width: 83.33%;
  }
  @media (min-width: 1200px) {
    max-width: 1200px;
    width: 83.33%;
  }

  @media (max-width: 768px) {
    display: ${({ none }) => (none ? 'none' : null)};
    flex-direction: column;
    padding: 15px 5px;
  }
`

export const StyledRow = styled(Row)`
  @media (max-width: ${sizes.small.max}) {
    padding: 20px 0px;
  }
`

export const StyledA = styled(A)`
  text-transform: initial;
  letter-spacing: 0.5px;
  color: #b4a06e;
  font-size: 16px;
  &:hover {
    text-decoration: underline;
  }
`

export const fontStack = css`
  font-family: 'Helvetica Neue', 'Arial', 'Verdana', '-apple-system',
    BlinkMacSystemFont, sans-serif;
  font-weight: 400;
  font-size: 18px;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  color: inherit;
  text-transform: none;
  text-align: inherit;
`

export const Heading = styled.h1`
  ${fontStack};
  font-weight: 600;
  letter-spacing: 0.4px;
  letter-spacing: normal;
  line-height: 1.2;
  margin-bottom: 20px;
`

export const H2 = styled(Heading)`
  // font-size: 2rem;
  font-size: 28px;
`

export const StyledH2 = styled(H2)`
  font-size: ${({ fontSize }) => fontSize || '14px'};
  // letter-spacing: 2px;
  letter-spacing: ${({ letterSpacing }) => letterSpacing || '2px'};
  line-height: 26px;
  padding: ${({ padding }) => padding || '0 0 4px'};
  ${({ noDivider }) =>
    !noDivider && 'border-bottom: 1px solid rgba(39, 37, 31, 0.2)'};
  text-transform: ${({ textCase }) => textCase || 'uppercase'};
  width: 100%;
  box-sizing: border-box;
  margin: ${({ margin }) => margin || '30px 0px 30px'};
  color: ${({ color }) => color || 'black'};
  &:hover {
    text-decoration: ${({ underline }) => (underline ? 'underline' : 'none')};
    cursor: ${({ underline }) => (underline ? 'pointer' : 'default')};
  }
`

export const ListH2 = styled(StyledH2)`
  padding: 12px 0px 12px 16px;
  &:before {
    content: '';
    background-color: #b4a06e;
    border-radius: 100%;
    display: block;
    position: absolute;
    top: 0px;
    left: -4px;
    height: 8px;
    width: 8px;
    z-index: 0;
  }
`

export const StyledSubtitle = styled.div`
  font-style: italic;
  font-size: 12px;
  padding-left: 16px;
`
